var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiCheckBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_3139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7535 32.7862C15.4411 33.0986 14.9347 33.0986 14.6223 32.7862L5.1486 23.3125C4.83623 23.0001 4.83623 22.4937 5.1486 22.1813L8.73249 18.5974C9.04517 18.2847 9.55223 18.2851 9.86447 18.5982L14.622 23.3692C14.9344 23.6825 15.4416 23.6827 15.7543 23.3697L31.1162 7.99231C31.4285 7.67967 31.9352 7.67954 32.2477 7.99202L35.8321 11.5764C36.1444 11.8888 36.1444 12.3952 35.8321 12.7076L15.7535 32.7862Z",
    fill: "#12F36C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_949_3139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7535 32.7862C15.4411 33.0986 14.9347 33.0986 14.6223 32.7862L5.1486 23.3125C4.83623 23.0001 4.83623 22.4937 5.1486 22.1813L8.73249 18.5974C9.04517 18.2847 9.55223 18.2851 9.86447 18.5982L14.622 23.3692C14.9344 23.6825 15.4416 23.6827 15.7543 23.3697L31.1162 7.99231C31.4285 7.67967 31.9352 7.67954 32.2477 7.99202L35.8321 11.5764C36.1444 11.8888 36.1444 12.3952 35.8321 12.7076L15.7535 32.7862Z",
    fill: "#12F36C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_949_3139",
    x: -1.61595,
    y: 1.22768,
    width: 44.2124,
    height: 38.3228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26501,
    result: "effect1_foregroundBlur_949_3139"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_3139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9933,
    height: 39.9933,
    fill: "white",
    transform: "translate(0.493164 0.392456)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCheckBold);
export default __webpack_public_path__ + "static/media/ci_check-bold.47cea0448692f4242cb41917c34cd08a.svg";
export { ForwardRef as ReactComponent };